import {Controller} from "@hotwired/stimulus";
import {Turbo} from "@hotwired/turbo-rails";


/**
 * Promote a visit when it's added to the DOM,
 * meant to be as a TurboStream response from the server
 *
 * This controller will self destruct
 */
export default class GoToController extends Controller {
  static values = {
    url: String,
    action: String
  }
  initialize() {
    if (this.hasUrlValue) {
      this.goTo(this.urlValue);
    }

    this.element.remove();
  }

  goTo(urlValue) {
    console.debug("GoTo", urlValue);

    if (urlValue === 'back') {
      history.back();
      return;
    }

    Turbo.visit(this.urlValue, {action: this.actionValue || 'advance'});
  }
}
